import type { ReactNode } from "react";

export type ManageFirmDashboardPanel = {
  id: string;
  render: () => ReactNode;
  /** Span both columns on xl+ (full row width). */
  fullWidth?: boolean;
};

type ManageFirmDashboardProps = {
  panels: ManageFirmDashboardPanel[];
};

export default function ManageFirmDashboard({
  panels,
}: ManageFirmDashboardProps): JSX.Element {
  return (
    <div className="grid w-full grid-cols-1 items-stretch gap-4 xl:grid-cols-2">
      {panels.map((panel) => (
        <div
          key={panel.id}
          className={`flex h-full min-h-0 w-full min-w-0 ${panel.fullWidth ? "xl:col-span-2" : ""}`}
        >
          <div className="flex h-full min-h-0 w-full">{panel.render()}</div>
        </div>
      ))}
    </div>
  );
}
